@if (showBreadcrumbs) {
  <wl-structured-data [structuredData]="structuredData" />
  <wl-breadcrumb [routes]="routes" />
}
